import z from 'zod'

import i18n from '@/shared/i18n/client'

export const schema = z.object({
	optimizationGroupIds: z.array(z.string()).min(1, {
		error: () =>
			i18n.t(
				'whatif.compare_scenarios.validation.optimization_group_required',
				{
					defaultValue: 'Please select at least one optimization group',
				}
			),
	}),
	globalSetIds: z.array(z.string()).min(1, {
		error: () =>
			i18n.t('whatif.compare_scenarios.validation.global_set_required', {
				defaultValue: 'Please select at least one global set',
			}),
	}),
	selectedValues: z.record(
		z.string(),
		z.record(
			z.string(),
			z
				.string({
					error: () =>
						i18n.t('whatif.compare_scenarios.validation.scenario_required', {
							defaultValue: 'Please select a scenario',
						}),
				})
				.min(1, {
					error: () =>
						i18n.t('whatif.compare_scenarios.validation.scenario_required', {
							defaultValue: 'Please select a scenario',
						}),
				})
		)
	),
})
